var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
//
// When imported, this file will load the code for the public website and set up `window.__versionSwitcherDefinition`.
// It is NOT exported from the package and should ONLY be referenced via the webpack helper under
// @fluentui/public-docsite-setup/scripts/getLoadSiteConfig.js.
//
// On the local and PR deploy sites, it uses `process.env.LOCAL_LIBRARY_VERSION` defined by the webpack
// helper to determine the current version of the main library (@fluentui/react or office-ui-fabric-react)
// and loads the served or deployed files specific to that local build or PR.
//
// On the real site, it loads a manifest file for the specified or latest major version and
// uses that to determine which files to load for the rest of the site.
//
import { BUNDLE_NAME, MANIFEST_NAME_FORMAT } from './constants';
var fabricVer = 'fabricVer';
var versions = [
    { name: 'Fluent UI React', major: '8' },
    { name: 'Fluent UI React', major: '7' },
    { name: 'Fabric React', major: '6' },
    { name: 'Fabric React', major: '5' },
];
var majorVersions = versions.map(function (v) { return v.major; });
var prod = 'prod';
var df = 'df';
/** All known hostnames the website can be run against */
var expectedHosts = __assign(__assign({}, (!!process.env.LOCAL && {
    local: ['localhost', '[::]', '127.0.0.1'],
    prDeploy: ['fluentuipr.z22.web.core.windows.net'],
})), (_a = {}, _a[df] = ['developer.microsoft-tst.com', 'uifabric-tst.azurewebsites.net'], _a[prod] = ['developer.microsoft.com', 'uifabric-prod.azurewebsites.net'], _a));
// Call the entry point
loadSite();
function loadSite() {
    var isDev = getParameterByName('dev') === '1' || !!getParameterByName('strict');
    var isProduction = !process.env.LOCAL || getParameterByName('prod') === '1' || getParameterByName('isProduction') === '1';
    var siteVariant = getSiteVariant();
    if (process.env.LOCAL && (siteVariant === 'prDeploy' || siteVariant === 'local' || !siteVariant)) {
        // Load the PR deployed site or locally served site.
        // (Also default to this for unknown hosts.)
        if (!siteVariant) {
            console.warn("Attempting to load local version of site for unknown host \"".concat(location.hostname, "\"."), "You may want to add this to expectedHosts in @fluentui/public-docsite-setup/src/loadSite.ts.");
        }
        if (!process.env.LOCAL_LIBRARY_VERSION) {
            throw new Error('LOCAL_LIBRARY_VERSION must be specified for PR deploy or locally served site');
        }
        loadSiteInternal({
            baseUrl: siteVariant === 'prDeploy'
                ? location.origin + location.pathname.replace('index.html', '')
                : location.origin + '/',
            isDemo: true,
            // filled in by webpack DefinePlugin
            libraryVersion: process.env.LOCAL_LIBRARY_VERSION,
            // default to loading dev build unless explicitly requested otherwise
            useMinified: isProduction,
        });
    }
    else if (siteVariant === prod || siteVariant === df) {
        // Load the real site (default to the most recent version). Note: the custom version logic is
        // only for the real site since PR deploy and local serve are tied to a specific version.
        var majorVersion = majorVersions[0];
        var versionFromUrl = getParameterByName(fabricVer);
        var versionFromStorage = sessionStorage.getItem(fabricVer);
        if (versionFromUrl && majorVersions.indexOf(versionFromUrl) !== -1) {
            majorVersion = versionFromUrl;
            sessionStorage.setItem(fabricVer, versionFromUrl);
        }
        else if (versionFromStorage && majorVersions.indexOf(versionFromStorage) !== -1) {
            majorVersion = versionFromStorage;
        }
        // NOTE: This filename must match what's generated by create-site-manifests.js.
        // siteVariant should be "df" or "prod" depending on domain.
        var manifestName = MANIFEST_NAME_FORMAT.replace('{major}', majorVersion).replace('{suffix}', siteVariant);
        var manifestUrl = "https://fabricweb.azureedge.net/fabric-website/manifests/".concat(manifestName);
        loadScript(manifestUrl, function () {
            var config = window.__siteConfig;
            if (config) {
                loadSiteInternal({
                    baseUrl: config.baseCDNUrl,
                    libraryVersion: config.libraryVersion,
                    // default to loading production (minified) build unless explicitly requested otherwise
                    useMinified: !isDev,
                });
            }
        });
    }
    else {
        // very much not expected, indicates something got out of sync
        throw new Error('Unexpected site variant: ' + siteVariant);
    }
}
function getSiteVariant() {
    var hostname = location.hostname;
    var variants = Object.keys(expectedHosts);
    for (var _i = 0, variants_1 = variants; _i < variants_1.length; _i++) {
        var variant = variants_1[_i];
        if (expectedHosts[variant].indexOf(hostname) !== -1) {
            return variant;
        }
    }
    return undefined;
}
function loadSiteInternal(options) {
    var baseUrl = options.baseUrl, libraryVersion = options.libraryVersion, useMinified = options.useMinified, isDemo = options.isDemo;
    var majorVersionMatch = libraryVersion.match(/^\d+/);
    var selectedVersion = versions.filter(function (v) { return v.major === (majorVersionMatch === null || majorVersionMatch === void 0 ? void 0 : majorVersionMatch[0]); })[0];
    if (!selectedVersion) {
        throw new Error("Invalid library version: ".concat(libraryVersion));
    }
    // Set up the version switcher definition to be used later
    window.__versionSwitcherDefinition = {
        selectedMajor: selectedVersion.major,
        selectedMajorName: "".concat(selectedVersion.name, " ").concat(libraryVersion),
        versions: versions.map(function (_a) {
            var name = _a.name, major = _a.major;
            return ({
                key: major,
                text: "".concat(name, " ").concat(major),
                // These menu items are also used in v5, where the "text" prop is called "name"
                name: "".concat(name, " ").concat(major),
                onClick: function () {
                    if (selectedVersion.major === major) {
                        return;
                    }
                    var url = window.location.href;
                    var versionParam = "".concat(fabricVer, "=").concat(major);
                    var newUrl;
                    if (getParameterByName(fabricVer)) {
                        // Replace existing fabricVer param
                        newUrl = url.replace(new RegExp("\\b".concat(fabricVer, "=(\\d+)")), versionParam);
                    }
                    else if (url.indexOf('?') !== -1) {
                        // Add param to existing query. (Note: not checking location.search directly since our hash-based
                        // URLs sometimes put the query after the hash.)
                        newUrl = url.replace('?', "?".concat(versionParam, "&"));
                    }
                    else {
                        // Add a query before the hash
                        var hash = location.hash;
                        newUrl = "".concat(url.replace(hash, ''), "?").concat(versionParam).concat(hash);
                    }
                    if (process.env.LOCAL && isDemo) {
                        // Demo sites only work with the specific version they were created against, so show
                        // an alert (including the new URL to help with debugging) but don't switch
                        // eslint-disable-next-line no-alert
                        alert("Demo sites can't switch versions. New URL if switching versions would be: ".concat(newUrl));
                    }
                    else {
                        location.href = newUrl;
                    }
                },
            });
        }),
    };
    // This is used by the example editor in 7+ (but having it defined in 5-6 is harmless)
    window.MonacoConfig = {
        baseUrl: baseUrl,
        useMinified: useMinified,
        crossDomain: true,
    };
    // Load the actual site
    var scriptUrl = "".concat(baseUrl).concat(BUNDLE_NAME).concat(useMinified ? '.min.js' : '.js');
    loadScript(scriptUrl, 
    /* onLoad */ undefined, 
    /* onError */ function () {
        // If requested version of the site (.js or .min.js) didn't exist, try the other version
        var newUseMinified = !useMinified;
        console.log("".concat(scriptUrl, " does not exist; trying ").concat(newUseMinified ? 'minified' : 'unminified', " version instead"));
        window.MonacoConfig.useMinified = newUseMinified;
        loadScript(scriptUrl.replace(/(\.min)?\.js$/, newUseMinified ? '.min.js' : '.js'));
    });
}
function getParameterByName(name) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(location.href);
    return !results ? undefined : !results[2] ? '' : decodeURIComponent(results[2].replace(/\+/g, ' '));
}
function loadScript(src, onLoad, onError) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = onLoad || null;
    script.onerror = onError || null;
    document.head.appendChild(script);
}
//# sourceMappingURL=loadSite.js.map